import { Handler } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

type Parameter = {
    unitOfMeasure: string;
    productId: string;
};

type HandlerType = Handler<Parameter>;

const ProductDetailsLoadRealTimeInventory: HandlerType = props => {
    const state = props.getState();
    const { productId} = props.parameter;
    const product = getProductState(state, productId).value;
    if (!product) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: [productId],
            onSuccess: realTimeInventory => {
                props.dispatch({
                    type: "Pages/ProductDetails/CompleteLoadRealTimeInventory",
                    realTimeInventory,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductDetails/FailedLoadRealTimeInventory",
                    productId
                });
            },
            onComplete(realTimeInventoryProps) {
                if (realTimeInventoryProps.apiResult) {
                    this.onSuccess?.(realTimeInventoryProps.apiResult);
                } else if (realTimeInventoryProps.error) {
                    this.onError?.(realTimeInventoryProps.error);
                }
            },
        }),
    );
};

export default ProductDetailsLoadRealTimeInventory;